module.exports = __webpack_public_path__ + "img/drops_600.f7f01b6a.png";